export default {
  title: {
    id: 'insurance_cart_modal_title',
    defaultMessage: 'Protection plans',
  },
  compliancyError: {
    id: 'trutpack_cgv_error',
    defaultMessage: 'Thanks for accepting the general buying conditions.',
  },
  confirm: {
    id: 'insurance_modal_confirm_cta',
    defaultMessage: 'Confirm',
  },
}
